"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usPhoneFormat = void 0;
const usPhoneFormat = (unFormattedNumber) => {
    if (unFormattedNumber) {
        const transformedInput = unFormattedNumber
            .replace(/[^0-9]/g, '')
            .replace(/^0+/, '');
        if (!isNaN(Number(transformedInput))) {
            const city = transformedInput.slice(0, 3);
            let number = transformedInput.slice(3);
            number = number.slice(0, 3) + '-' + number.slice(3);
            return ('(' + city + ') ' + number).trim();
        }
    }
    return unFormattedNumber;
};
exports.usPhoneFormat = usPhoneFormat;
